<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/pvrbBA/tc-custom/9781504088022.jpg?1718282806581" alt="This image is the cover for the book Into the Thinking Kingdoms, Journeys of the Catechist"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Into the Thinking Kingdoms, Journeys of the Catechist
      </h1>
      <p class="bookDescription body article font2">
        <b>From the <i>New York Times</i>–bestselling author of <i>Carnivores of Light and Darkness</i> comes the second fantasy adventure in the Journeys of the Catechist saga.</b><br/><br/> With his two companions—Simna ibn Sind the swordsman and the massive black cat Ahlitah—at his side, Etjole Ehomba continues his honor-driven quest to find the Visioness of Laconda. Imprisoned in the fortress of an evil necromancer, she is both her captor’s obsession and his torment.<br/><br/> Seeking to cross the blighted Semordria Ocean, Etjole and his sidekicks find no one willing to risk its legendary monsters—until they meet a collector of rare animals. He points them to the northern realm of Hamacassar, and then drugs them in order to steal Ahlitah. Escaping the man’s conjured assassins, the trio head to the Thinking Kingdoms, across snow-covered mountains to Laconda, with danger and dark magic nipping at their heels . . .<br/><br/><b>“Foster’s latest series combines elements of epic fantasy with folkloric motifs in an engaging picaresque tale of a simple man’s honor-bound journey into adventure.” —<i>Library Journal</i></b><br/><br/><b>“The story’s swift pace and Foster’s boundless imagination deliver something very different from the usual fantasy quest saga. In these magical lands, Foster shows that character and common sense can be as important, and as powerful, as any magic.” —<i>Publishers Weekly</i></b><br/><br/><b>“There’s no doubt that Alan Dean Foster is a master storyteller. I finished <i>Into the Thinking Kingdoms</i> in a single sitting.” —<i>Black Gate</i></b><br/><br/><b>“Splendidly packed with illustrious incidents, not to mention a protagonist who grows steadily more intriguing and enigmatic.” —<i>Kirkus Reviews</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Alan Dean Foster
      </h2>
      
      <p class="authorDescription body article">The&#160;<I>New York Times</I>&ndash;bestselling author of more than one hundred ten books, Alan Dean Foster is one of the most prominent writers of modern science fiction. Born in New York City in 1946, he studied filmmaking at UCLA, but first found success in 1968 when a horror magazine published one of his short stories. In 1972 he wrote his first novel,&#160;<I>The Tar-Aiym Krang</I>, the first in his Pip and Flinx series featuring the Humanx Commonwealth, a universe he has explored in more than twenty-five books. He also created the Spellsinger series, numerous film novelizations, and the story for&#160;<I>Star Trek: The Motion Picture.</I>&#160;An avid world traveler, he lives with his family in Prescott, Arizona.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?06f770a9